import { render, staticRenderFns } from "./ProdutoSazonal.vue?vue&type=template&id=1b671b1e"
import script from "./ProdutoSazonal.vue?vue&type=script&lang=js"
export * from "./ProdutoSazonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports